import styled from 'styled-components';

const WorkIndividualStyle = styled.section`
	&.SinglePortfolioPage {
		.sectionItem {
			margin-bottom: var(--sp8x);
		}

		.portfolioSingleCont {
			> div {
				margin-bottom: var(--portfolioItemMarg);

				&:last-child {
					margin-bottom: 0;
				}
			}

			> h4 {
				margin-top: calc(var(--portfolioItemMarg) + var(--sp3x));
				margin-bottom: var(--sp3x);
			}

			> p {
				margin-bottom: calc(var(--portfolioItemMarg) + var(--sp3x));
			}
		}

		.portfolioWrap {
			.portfolioItem {
				padding: calc(var(--portfolioItemMarg) / 2) 0;

				a {
					display: block;
				}

				.image_video_cont {
					position: relative;
					margin-bottom: var(--sp2-5x);

					.image_video {
						padding-top: 75%;
					}

					video {
						position: absolute;
						z-index: 1;
						inset: 0;
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}

				h5,
				p {
					margin-bottom: var(--sp1x);

					&:last-child {
						margin-bottom: 0;
					}
				}
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
				--itemMarg: calc(var(--portfolioItemMarg) / 2);

				display: flex;
				flex-wrap: wrap;
				margin: 0 calc(var(--portfolioItemMarg) / 2 * -1);

				.portfolioItem {
					width: 50%;
					padding: var(--sp8x) var(--itemMarg) var(--sp5x);
				}
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
				justify-content: flex-end;

				.portfolioItem {
					width: 42%;
					padding: var(--sp3x) var(--itemMarg) var(--sp5x);
				}
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
				.portfolioItem {
					padding: var(--sp3x) var(--itemMarg) 0;
				}
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
				.portfolioItem {
					width: 37%;
					padding: var(--sp8x) var(--itemMarg) 0;
				}
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
				.portfolioItem {
					padding: var(--sp10x) var(--itemMarg) 0;
				}
			}

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
				.portfolioItem {
					.image_video_cont {
						.image_video {
							margin-bottom: var(--sp5x);
						}
					}

					h5,
					p {
						margin-bottom: var(--sp1x);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.portfolioSingleCont {
				> h4 {
					max-width: 90%;
				}

				> p {
					max-width: 52%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.portfolioSingleCont {
				> h4 {
					max-width: 69%;
				}

				> p {
					max-width: 48%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.portfolioSingleCont {
				> h4 {
					margin-bottom: var(--sp4x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.sectionItem {
				margin-bottom: var(--sp9x);
			}

			.portfolioSingleCont {
				> h4 {
					max-width: 65%;
				}
				> p {
					max-width: 45%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.sectionItem {
				margin-bottom: var(--sp10x);
			}

			.portfolioSingleCont {
				> h4 {
					max-width: 64%;
				}

				> p {
					max-width: 42%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			.sectionItem {
				margin-bottom: var(--sp11x);
			}

			.portfolioSingleCont {
				> h4 {
					max-width: 79%;
				}

				> p {
					max-width: 44%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			.portfolioSingleCont {
				> h4 {
					max-width: 90%;
					margin-top: calc(var(--portfolioItemMarg) + var(--sp5x));
					margin-bottom: var(--sp5x);
				}

				> p {
					max-width: 50%;
					margin-bottom: calc(var(--portfolioItemMarg) + var(--sp5x));
				}
			}

			.sectionItem {
				margin-bottom: var(--sp12x);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			.portfolioSingleCont {
				> h4 {
					max-width: 71%;
					margin-top: calc(var(--portfolioItemMarg) + var(--sp4x));
					margin-bottom: var(--sp5x);
				}

				> p {
					max-width: 38%;
					margin-bottom: calc(var(--portfolioItemMarg) + var(--sp4x));
				}
			}

			.sectionItem {
				margin-bottom: var(--sp15x);
			}
		}
	}
`;

export default WorkIndividualStyle;
